import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;

  button:last-of-type {
    width: 9.75rem;
    height: 3rem;
    margin-left: auto;
    margin-right: 2rem;
    background-color: var(--white);
  }
`;

export const Form = styled.form`
  display: grid;
  row-gap: 1rem;
  column-gap: 2rem;
  margin-bottom: 0.7rem;

  input {
    width: 100%;
  }
`;

export const Map = styled.div`
  gap: 2rem;
  display: flex;
  width: 100%;
`;

export const MapError = styled.small`
  color: #ff6565;
  font-size: 13.5px;
  font-family: IBM Plex Sans;
  line-height: 12px;
  margin-top: 0.5rem;
`;
